import Vue from 'vue'
import helpers from '@/helpers/helpers.js'

Vue.mixin({
    methods: helpers
})
